import { useEffect } from "react";
import { TextField } from '@mui/material';
import flatpickr from "flatpickr";
import { Czech } from "flatpickr/dist/esm/l10n/cs";
import CSS from 'csstype';

import { formatDate } from "~/utils/utils";
import { useNonHookTrans } from "~/hooks/useTrans";
import { myUseState } from "~/hooks/myUseState";

interface IState {
	set: boolean;
	validTill: string;
}

interface IValidTillInput {
	value: string;
	onChange: (newDate: Date) => void;
	isCzech?: boolean
	label?: string;
	sx?: CSS.Properties;
}

export default function ValidTillInput({
	label = useNonHookTrans().trans("createProject.validTill"),
	onChange = () => {},
	value = "",
	isCzech = false,
	sx = {},
}: IValidTillInput) {
	const { state, updateState } = myUseState<IState>({
		set: false,
		validTill: "",
	});

	function setInput(target: HTMLElement) {
		if (!state.set) {
			flatpickr(target, {
				enableTime: false,
				dateFormat: isCzech ? "j. n. Y" : "m/d/Y",
				disableMobile: true,
				position: "below center",
				positionElement: target,
				monthSelectorType: "static",
				allowInput: false,
				onChange: selectedDates => {
					const curDate = selectedDates[0];

					onChange(curDate);
					updateState({
						validTill: formatDate(curDate, isCzech),
					});
				},
				...isCzech
					? {
						locale: Czech,
					}
					: {},
			});

			updateState({
				set: true,
			});
		}
	}

	useEffect(() => {
		updateState({
			validTill: value ? formatDate(new Date(value), isCzech) : "",
		});
	}, [value]);

	return <TextField
		label={label}
		value={state.validTill}
		onChange={() => {}}
		onPointerDown={event => setInput(event.target as HTMLElement)}
		size="small"
		inputProps={{
			autoComplete: "off",
		}}
		sx={{ width: "100%", ...sx }}
	/>;
}
